export default "__VITE_ASSET__IjnWygHS__"